import { DBDef_NoteTemplate } from '@app/advisor-content-shared';
import { createSearchIntegration } from '@app/styles';
import { ModuleFE_NoteTemplate } from '../../_entity/note-template/ModuleFE_NoteTemplate.js';
import { ModuleFE_SmartDoc } from '../../_entity/smart-doc/ModuleFE_SmartDoc.js';
import { Manager_NoteTemplate } from '../../ui/_managers/Manager_NoteTemplate/Manager_NoteTemplate.js';
import { ConfigDialogKeys_AdvisorContent, ConfigDialogs_AdvisorContent_Dialogs, ConfigDialogs_AdvisorContent_Labels } from '../../ui/config-dialogs/index.js';
const { WorkHubItem, UtilObject, SearchItem } = createSearchIntegration({
    module: ModuleFE_NoteTemplate,
    dbDef: DBDef_NoteTemplate,
    tag: ['Nt', 'Note Template'],
    modulesToAwait: [ModuleFE_NoteTemplate, ModuleFE_SmartDoc],
    ManagerComponent: Manager_NoteTemplate,
    extraMenuSections: () => [{
            actions: ConfigDialogKeys_AdvisorContent.map(key => ({
                label: ConfigDialogs_AdvisorContent_Labels[key],
                action: () => ConfigDialogs_AdvisorContent_Dialogs[key].show(),
            })),
        }],
});
export const WorkHubItem_NoteTemplate = WorkHubItem;
export const UtilObject_NoteTemplate = UtilObject;
export const SearchItem_NoteTemplate = SearchItem;
//# sourceMappingURL=note-template.js.map